export const surveyMessages = {
  SURVEY_INPUT_INVALID: '설문 입력값과 문항·보기를 확인해 주세요.',
  SURVEY_NOT_FOUND: '설문 정보를 찾을 수 없습니다.',
  SURVEY_VERSION_CONFLICT: '설문 정보가 변경되었습니다. 입력 내용을 확인한 뒤 최신 정보를 불러와 주세요.',
  SURVEY_CATEGORY_UNAVAILABLE: '사용할 수 있는 설문 분류를 선택해 주세요.',
  SURVEY_CATEGORY_REFERENCED: '설문에서 사용 중인 분류는 삭제할 수 없습니다.',
  SURVEY_SYSTEM_CATEGORY_RESERVED: '수강만족도는 시스템 전용 분류명입니다. 다른 이름을 사용해 주세요.',
  SURVEY_IMMUTABLE: '확정하거나 보관한 설문은 수정할 수 없습니다. 새 초안으로 복사해 주세요.',
  SURVEY_UNCONFIRMED: '문항을 확정한 설문을 선택해 주세요.',
  SURVEY_BINDING_IMMUTABLE: '공개한 설문 연결과 응답 조건은 변경할 수 없습니다.',
  SURVEY_BINDING_DUPLICATE: '이미 연결한 설문이거나 사전 설문이 등록되어 있습니다.',
  SURVEY_OPENING_UNAVAILABLE: '현재 설문을 운영할 수 있는 개설 상태가 아닙니다.',
  SURVEY_WINDOW_INVALID: '설문 기간을 해당 학습기간 안으로 설정해 주세요.',
  SURVEY_WINDOW_UNAVAILABLE: '현재 설문 응답 기간이 아닙니다.',
  SURVEY_TRIGGER_INVALID: '해당 개설의 공개 시험 또는 학습 차시를 선택해 주세요.',
  SURVEY_TRIGGER_WAITING: '설문 참여에 필요한 진도·시험·차시 조건을 아직 충족하지 않았습니다.',
  SURVEY_PRE_REQUIRED: '사전 설문을 먼저 완료해 주세요. 나의강의실의 “설문 참여·응답 확인”에서 참여할 수 있습니다.',
  SURVEY_PRE_TOO_LATE: '학습·평가·설문 참여가 시작된 개설에는 사전 필수 설문을 추가할 수 없습니다.',
  SURVEY_NOT_PUBLISHED: '현재 설문 응답이 공개되어 있지 않습니다.',
  SURVEY_NOT_STARTED: '설문 응답 시작 전입니다.',
  SURVEY_PERIOD_ENDED: '설문 응답 기간이 종료되었습니다.',
  SURVEY_REQUIRED_ANSWER: '필수 문항에 모두 답변해 주세요.',
  SURVEY_REQUEST_CONFLICT: '이전에 보낸 요청과 내용이 다릅니다. 최신 제출 결과를 확인해 주세요.',
  SURVEY_ALREADY_SUBMITTED: '이미 제출한 설문입니다. 최신 정보를 불러와 응답을 확인해 주세요.',
}
export const surveyState = value => ({ DRAFT: '초안', CONFIRMED: '확정', ARCHIVED: '보관', PUBLISHED: '공개', PAUSED: '중지', AVAILABLE: '참여 가능', COMPLETED: '참여 완료', PRE: '사전 설문', REGULAR: '일반 설문', TEXT: '서술형', RADIO: '단일 선택', OX: 'O/X', SCORE: '점수 척도', IMMEDIATE: '즉시', PROGRESS: '진도 충족', TEST_COMPLETE: '시험 제출 완료', LESSON_COMPLETE: '차시 학습 완료' }[value] || surveyMessages[value] || value)
export const surveyTime = value => value ? new Date(value).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' }) : '미정'
